/** Back link of the full-label page: the keyword tab it came from, or plain back. */
import React, { useContext } from 'react';
import { ShellContext } from '../../shell/shellContext';
import type { ShellApi } from '../../shell/types';

export function backLinkState(
  shell: ShellApi | null,
  from: string | null,
): { label: string; target: 'focus' | 'back' } {
  if (!shell || !from || !shell.tabs.some((t) => t.id === from)) {
    return { label: '← Back', target: 'back' };
  }
  const run = shell.runs[from];
  if (run?.kind === 'set' && run.capability === 'keyword') {
    const resp = run.response as { total_count?: unknown; count_is_windowed?: boolean } | null;
    if (typeof resp?.total_count === 'number') {
      const n = resp.total_count;
      const windowed = !!resp.count_is_windowed;
      return {
        label: `← ${n}${windowed ? '+' : ''} keyword result${n === 1 && !windowed ? '' : 's'}`,
        target: 'focus',
      };
    }
  }
  return { label: '← Keyword results', target: 'focus' };
}

const LabelBackLink: React.FC<{ fromTabId: string | null; onBack: () => void }> = ({ fromTabId, onBack }) => {
  const shell = useContext(ShellContext);
  const { label, target } = backLinkState(shell, fromTabId);
  return (
    <button
      type="button"
      className="self-start text-[13px] text-accent hover:underline"
      onClick={() => (target === 'focus' && shell && fromTabId ? shell.focusTab(fromTabId) : onBack())}
    >
      {label}
    </button>
  );
};

export default LabelBackLink;
